import { z } from 'zod';
import { minorUnitsFromAmount } from '@shared/components/form/config-value';
import { CHOOSE_CHANNEL_MESSAGE } from '../utils/motorplanPaymentCopy';
import { amountLimitMessage, type MotorplanAmountLimits } from '../utils/motorplanAmount';

const TWO_DP = /^\d+(\.\d{1,2})?$/;

export const motorplanPaymentSchema = (limits: MotorplanAmountLimits) =>
    z
        .object({
            amountGross: z
                .string()
                .trim()
                .superRefine((value, ctx) => {
                    if (!TWO_DP.test(value)) {
                        ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Enter an amount in pounds and pence' });
                        return;
                    }
                    const message = amountLimitMessage(minorUnitsFromAmount(value) ?? 0, limits);
                    if (message) ctx.addIssue({ code: z.ZodIssueCode.custom, message });
                }),
            sendViaEmail: z.boolean(),
            sendViaSms: z.boolean(),
        })
        .refine((values) => values.sendViaEmail || values.sendViaSms, {
            message: CHOOSE_CHANNEL_MESSAGE,
            path: ['sendViaEmail'],
        });

export type MotorplanPaymentValues = z.infer<ReturnType<typeof motorplanPaymentSchema>>;
